import React, { useEffect, useState } from 'react';
import {
  getReadableTimeZoneDateTime,
  getTimeZoneDataByOffsetInMinutes,
} from 'services';
import Typography from '@mui/material/Typography';

export const LocalTzTime = ({ offset }: { offset: number }) => {
  const [dateTime, setDateTime] = useState(
    getReadableTimeZoneDateTime(getTimeZoneDataByOffsetInMinutes(offset))
  );
  useEffect(() => {
    const interval = setInterval(
      () =>
        setDateTime(
          getReadableTimeZoneDateTime(getTimeZoneDataByOffsetInMinutes(offset))
        ),
      1000
    );

    return () => {
      clearInterval(interval);
    };
  }, []);
  return (
    <Typography color="grey.300" variant="textSmall">
      {dateTime}
    </Typography>
  );
};
